import React, { useEffect, useState } from 'react';
import MainButton from '../../../theme/MainButton';
import Grid from '@material-ui/core/Grid';
import Label16 from '../../../theme/labels/Label16';
import EditOrganizationInfoModal from './EditOrganizationInfoModal/EditOrganizationInfoModal';
import EditUserInfoModal from './EditUserInfoModal';
import SignupContentWrapper from './SignupContentWrapper';
import { finalStepStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store';
import { PATH } from '../../../routes';
import { useNavigate } from 'react-router-dom';
import { addPhoneNumberFormatting } from '../../../store/signup/reducer';
import { pushEvent } from '../../../utils/clevertapUtils';
import {
    CLICK_FINAL_PAGE_CONTINUE_BTN,
    VIEW_FINAL_PAGE,
} from '../../../utils/clevertapEvents';
import { useRouteConfig } from '../utils/useRouteConfig';
import { whichStepsAreMissing } from '../../../store/signup/types';

const FinalStep: React.FC = () => {
    const { t } = useTranslation();
    const push = useNavigate();
    const [openOrganizationEdit, setOpenOrganizationEdit] =
        useState<boolean>(false);
    const { reviewSignup, topGridStyles } = finalStepStyles();
    const { next, previous } = useRouteConfig(PATH.SIGNUP.STEPS.FINAL_STEP);
    const { signUp } = useSelector((state: AppState) => ({
        signUp: state.Signup,
    }));
    useEffect(() => {
        pushEvent(VIEW_FINAL_PAGE);
    }, []);
    const signUpCompleted = (): boolean => {
        const missingSteps = whichStepsAreMissing(signUp);
        if (missingSteps.find((x) => x.route === PATH.SIGNUP.STEPS.ONE)) {
            setOpenOrganizationEdit(true);
        }
        return missingSteps.length === 0;
    };
    const onClick = () => {
        pushEvent(CLICK_FINAL_PAGE_CONTINUE_BTN);
        if (signUpCompleted()) {
            next && push(next);
        }
    };
    return (
        <SignupContentWrapper
            heading={t('signup.reviewStep.heading')}
            stepInfo={undefined}
            showCloseButton={true}
            backUrl={previous}
        >
            <Grid container className={reviewSignup} justify="space-evenly">
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    className="grid-wrapper grey-border-right"
                >
                    <div className={topGridStyles}>
                        <Label16 isBold className="left">
                            {t('signup.reviewStep.organizationInfo')}
                        </Label16>
                        <EditOrganizationInfoModal
                            open={openOrganizationEdit}
                            setOpen={setOpenOrganizationEdit}
                        />
                    </div>
                    <div className="grid">
                        <Label16 isBold>{signUp.organizationName}</Label16>
                        <Label16>{signUp.organizationAddress}</Label16>
                        <Label16>{signUp.organizationZip}</Label16>
                        <Label16>
                            {addPhoneNumberFormatting(
                                signUp.organizationPhoneNumber,
                            )}
                        </Label16>
                        {signUp.ein && <Label16>EIN {signUp.ein}</Label16>}
                    </div>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    className="grid-wrapper grid-right"
                >
                    <div className={topGridStyles}>
                        <Label16 isBold className="left">
                            {t('signup.reviewStep.personalInfo')}
                        </Label16>
                        <EditUserInfoModal />
                    </div>
                    <div className="grid">
                        <Label16>
                            {signUp.userFirstName} {signUp.userLastName}
                        </Label16>
                        <Label16>{signUp.userEmail}</Label16>
                        <Label16>
                            {addPhoneNumberFormatting(signUp.userPhone)}
                        </Label16>
                    </div>
                </Grid>
            </Grid>
            <MainButton text={t('labels.continue')} onClick={onClick} />
        </SignupContentWrapper>
    );
};

export default FinalStep;
